import { Button } from 'tradera/components/atoms/button/button';
import MessageIcon from '@tradera/blueprint/theme/icons2/message.svg?jsx';
import { useUrlLocalizer } from 'tradera/lang/translate';
import { useGetMessagingStatsQuery } from 'tradera/state/services/messaging-stats-api';
import { useIsFeatureEnabled } from 'tradera/hooks/use-is-feature-enabled';
import { HeaderBadge } from 'tradera/components/site-header/header-badge';

export const MessagingLink = () => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const isMessagingEnabled = useIsFeatureEnabled('messaging');

    const { data: messagingStatsData } = useGetMessagingStatsQuery(undefined, {
        refetchOnMountOrArgChange: 30,
        skip: !isMessagingEnabled,
    });

    const { threadsUnread = 0 } = messagingStatsData || {};

    return (
        <Button
            theme="text"
            className="slim-header__button"
            href={toLocalizedUrl('/messaging')}>
            <MessageIcon className="icon icon-md" />
            {threadsUnread > 0 && <HeaderBadge count={threadsUnread} />}
        </Button>
    );
};
